import usePermissions, {
  hasPermissions,
  type PermissionRequest,
} from '@/common/hooks/usePermissions.ts';
import { type ReactNode } from 'react';

export default function PermissionRequired({
  permission,
  children,
}: {
  permission: PermissionRequest;
  children: ReactNode;
}) {
  const permissions = usePermissions();

  if (permissions.isPending) return null;

  return hasPermissions(permissions.data, permission) ? children : null;
}
